import "./App.css";

const App = () => {
  window.location.replace("/dervilo.html");
  return <></>;
};

export default App;
